module.exports = __webpack_public_path__ + "media/52.dbdc2d71.wav";